import React from 'react';

import { FeatureFlagsContextType } from './types';

export const FeatureFlagsContext = React.createContext<FeatureFlagsContextType>({} as FeatureFlagsContextType);
